export default __webpack_public_path__ + "static/media/type_15_9.b521651e.svg";